import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Button} from '@betareader/design-system';
import AppIcon from '../../components/AppIcon';

const BackMenuButton = ({
  toPath,
  t,
  changePage,
}) => {
  return (
    <div>
      <Button
        onClick={() => changePage(toPath)}
        variant='ghost'
        size='small'
        aria-label={t('Back')}
      ><AppIcon name='chevron left' aria-hidden='true' /></Button>
    </div>
  );
}

// redux stuff
const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BackMenuButton)));
